import { render, staticRenderFns } from "./NutritionalTable.vue?vue&type=template&id=6fbea7bc&"
import script from "./NutritionalTable.vue?vue&type=script&lang=js&"
export * from "./NutritionalTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports